export default async function rfetch(
  url,
  init,
  { timeout = 1000, maxRetries = null, counter = 0 }
) {
  let controller = new AbortController();
  let { signal } = controller;
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);
  let response;
  try {
    response = await fetch(url, { ...init, signal });
    clearTimeout(timeoutId);
    return response;
  } catch (e) {
    if (signal.aborted) {
      counter++;
      if (!maxRetries || counter < maxRetries) {
        try {
          timeout+=500
          response = await rfetch(url, init, { maxRetries, timeout, counter });
          return response;
        } catch (e) {
          throw e;
        }
      } else {
        throw new Error("Max Retries reached!");
      }
    } else {
      clearTimeout(timeoutId);
      throw e;
    }
  }
}
